import { SentryLogger as Sentry } from '@ers/errors';

export default class FileHelper {
    static openFileInNewWindow=(file) => {
        try {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
            } else {
                const url = window.URL.createObjectURL(file);
                const w = window.open(url, '_blank');
                if (w) {
                    w.focus();
                } else {
                    FileHelper.downloadFile(file);
                }
            }
        } catch (e) {
            Sentry.error(e);
        }
        window.URL.revokeObjectURL(file);
    }

    static downloadFile = ({ blob, fileName }) => {
        const file = blob;
        const url = window.URL.createObjectURL(file);
        const a = FileHelper.createTempAnchor(url, fileName);
        a.click();
        window.URL.revokeObjectURL(file);
    }

    static b64toBlob = ({ content, contentType = '' }, sliceSize = 512) => {
        const byteCharacters = atob(content);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    static sizeToDisplay(bytes) {
        const mega = 1024 * 1024;
        const kilo = 1024;
        if (bytes > mega) {
            return `${Math.round(bytes / (mega / 100)) / 100} MB`;
        }
        if (bytes > kilo) {
            return `${Math.round(bytes / (kilo / 100)) / 100} KB`;
        }
        return `${bytes} B`;
    }

    static createTempAnchor(url, label) {
        const temporaryLink = document.createElement('a');
        temporaryLink.href = url;
        temporaryLink.download = label;
        return temporaryLink;
    }
}